import { Content } from '../../types';

export const paiContent: Content = {
  title: 'פאי - העיירה הציורית בצפון תאילנד',
  imageUrl: '/images/thailand/pai/pai-wide.jpeg',
  introduction: `פאי Pai, הינה עיירה קטנה ושלווה, ציורית ומוקפת בטבע פראי, הממוקמת בלב הרי מחוז מה הונג סון שבצפון תאילנד, לא הרחק מהגבול עם מיאנמר (בורמה). עם אוכלוסייה קטנה ואווירה בוהמיינית, מושכת אליה פאי, תרמילאים, זוגות ומשפחות המחפשים חוויה שונה מהמולת הערים הגדולות. הבתים המסורתיים, הנוף ההררי והנהר הזורם יוצרים תחושת שלווה שאין דומה לה והשוהים במקום יכולים לנשום עמוק ולהתחבר לטבע ולפשטות.`,
  sections: [
    {
      title: 'הדרך אל פאי - חוויה בפני עצמה',
      type: 'text',
      content: `הנסיעה מצ'אנג מאי לפאי אורכת כ - 3 עד 4 שעות ולאורכה, מעל 760 פיתולים חדים בקטע הדרך ההררית. הנופים שבדרך מרהיבים - יערות ירוקים, כפרים קטנים ופסגות הרים. מומלץ להצטייד בכדורים נגד בחילה, לעשות את הדרך באמצעות רכב שכור, מה שיאפשר לכם לעצור בנקודות הרלוונטיות שבדרך. ניתן גם לשכור קטנוע, אך אופציה זו מתאימה בעיקר למטיילים מנוסים.`,
    },
    {
      title: 'אווירה ייחודית ותיירות מתפתחת',
      type: 'text',
      content: `בעבר, הייתה פאי כפר שקט וכמעט אנונימי, אך בעשור האחרון הפכה ליעד מבוקש. היא שומרת על אווירה נינוחה עם מוזיקה חיה, ברים קטנים, מסעדות טבעוניות, סדנאות יוגה ומדיטציה. המטיילים מגיעים ע"מ להאט את הקצב, לפגוש אנשים מכל העולם וליהנות מהשילוב שבין פשטות כפרית לתרבות בינלאומית.`,
    },
    {
      title: 'הרחובות המרכזיים ושוק הלילה',
      type: 'sub-headers',
      description: 'הרחובות המרכזיים של פאי:',
      content: [
        {
          subtitle: 'Rangsiyanon Road',
          text: 'הרחוב הראשי המוביל אל מרכז פאי, רחוב שלאורכו תמצאו סוכנויות טיולים, בנקים, חנויות נוחות ובתי קפה. זהו הציר המרכזי המחבר את הכניסה לעיירה עם חיי היומיום של המקומיים והתיירים.',
        },
        {
          subtitle: 'Chai Sangkhram Road',
          text: 'הלב הפועם של העיירה, ה - Walking Street הפופולרי של פאי, רחוב שמקבל חיים חדשים מדי ערב, בדגש על שוק הלילה, בו מוצעים שפע של דוכני אוכל רחוב מעולה (כולל טבעוני וצמחוני), תכשיטים, בגדים בעבודת יד ואומנות מקומית. בלילות שוקק רחוב זה באווירה צעירה עם מוזיקה, מופעי רחוב ותחושת חופש כללית.',
        },
      ],
    },
    {
      title: 'מזג אוויר בפאי',
      type: 'sub-headers',
      description:
        'מזג האוויר בפאי נחלק לשלוש עונות עיקריות, כאשר התקופה המומלצת ביותר לביקור הינה בין נובמבר למרץ, אז הטמפרטורות נוחות והגשם מועט.',
      content: [
        {
          subtitle: 'נובמבר - מרץ',
          text: 'העונה היבשה והמומלצת ביותר לטיול - מזג אוויר נעים ביום וקריר בלילה, עם שמיים בהירים.',
        },
        {
          subtitle: 'אפריל - מאי',
          text: 'חם במיוחד, לפעמים מעל 35 מעלות. בתקופה זו, מתקיימות גם שריפות חקלאיות המפחיתות את איכות האוויר.',
        },
        {
          subtitle: 'יוני - אוקטובר',
          text: 'העונה הגשומה - העמק כולו נצבע בירוק עז, אך ייתכנו הצפות ודרכים חלקות.',
        },
      ],
    },
    {
      title: 'אזורי לינה מומלצים בפאי',
      type: 'sub-headers',
      description:
        'למרות גודלה הקטן, מחולקת העיירה למספר אזורי לינה עיקריים - כל אחד מהם מתאים לסוג שונה של מטיילים:',
      content: [
        {
          subtitle: 'מרכז העיירה (Walking Street והסביבה)',
          text: 'החלק המרכזי של פאי, סמוך לשוק הלילה ולרחובות Rangsiyanon ו - Chai Sangkhram, מציע גישה נוחה לכל מה שתבקשו - מסעדות, ברים, שוק הלילה וסוכנויות טיולים. מתאים לתרמילאים, זוגות צעירים ולאלו המעדיפים לשהות בקרבת הכול.<br/><strong>מלונות מומלצים:</strong> Pai Village Boutique Resort & Farm, Family House Zen Boutique Resort, The Quarter Pai<br/><strong>מסעדות באזור:</strong> Charlie & Lek, Nong Beer Restaurant',
        },
        {
          subtitle: 'אזור הנהר',
          text: 'שקט, טבעי ורומנטיקה - אזור זה מציע לינה באווירה פסטורלית עם נוף ירוק, עצים ושדות אורז. זהו אזור מושלם למחפשים שלווה אך עדיין מעוניינים להיות בטווח הליכה מהמרכז. מתאים לזוגות, משפחות ולמחפשים רוגע ושלווה.<br/><strong>מלונות מומלצים:</strong> Reverie Siam Resort, Yoma Hotel Pai<br/><strong>מסעדות באזור:</strong> Go Heng Cafe by Boomelicious Cafe, Art in Chai, Silhouette By Reverie Siam',
        },
        {
          subtitle: 'האזור הכפרי',
          text: 'לחובבי טבע ובידוד - המחפשים חוויה אותנטית יותר, יכולים לבחור ללון באזורים שמחוץ לעיירה - שדות ירוקים, חוות אורגניות ונוף להרים. מתאים לתרמילאים הרפתקנים, מטיילים רוחניים ומטיילי סולו, המטיילים עם רכב/קטנוע.<br/><strong>מלונות מומלצים:</strong> Reverie Siam Resort, The Oia Pai Resort, SpicyPai Backpackers (הוסטל - מתאים עבור תרמילאים)<br/><strong>מסעדות באזור:</strong> Earth Tone Café, Café de Pai, Baanpizza',
        },
        {
          subtitle: '',
          text: '<strong>טיפ -</strong> בעונת השיא (נובמבר-פברואר), מומלץ להזמין מראש, מאחר והמקומות הטובים נתפסים במהירות.',
        },
      ],
    },
    {
      title: 'דרכי הגעה לפאי',
      type: 'sub-headers',
      description:
        "פאי ממוקמת כ - 135 ק\"מ צפונית מערבית לצ'אנג מאי והדרך אליה נחשבת לאחת היפות והמרתקות בתאילנד, עם כ - 760 פיתולים חדים בכביש ההררי המוביל אליה. למרות זאת, מדובר בנסיעה בטוחה ומבוקשת, עם מגוון אפשרויות הגעה מצ'אנג מאי.",
      content: [
        {
          subtitle: 'רכב פרטי/ אופנוע',
          text: 'נסיעה של כ - 3 עד 4 שעות עם כ - 760 פיתולים מרהיבים בכביש אך עם אפשרות לעצור בנקודות עניין בדרך וישנן לא מעט כאלו - האופציה המומלצת ביותר. במידה ובחרתם באופנוע - חובה נסיון ברכיבה וזהירות רבה בדרך המפותלת.',
        },
        {
          subtitle: 'מיניוואן',
          text: 'יוצאים מהתחנה המרכזית Arcade Terminal מספר פעמים ביום, בנסיעה הנמשכת כ -3.5 עד 4 שעות. המושבים נוחים יחסית, אך חשוב להבין כי הפיתולים עלולים לגרום לבחילות ולכן, מומלץ להצטייד מראש בכדורים נגד בחילות. <br/><strong>העלות:</strong> כ - 150 באט לכיוון.',
        },
        {
          subtitle: 'טיסה',
          text: 'נכון לעכשיו אין טיסות לפאי. בעבר פעל בעיירה שדה תעופה קטן ולכן, שווה לעקוב אחר עדכונים בנושא.',
        },
        {
          subtitle: "מוניות/ רכב פרטי עם נהג מצ'אנג מאי",
          text: "למטיילים המעדיפים נוחות ופרטיות ואינן מעוניינים לשכור רכב, ניתן להזמין מונית/ רכב פרטי עם נהג מצ'אנג מאי. שירות נוח בהרבה מהמיניוואנים ומתאים למשפחות או זוגות.",
        },
      ],
      is12GoBanner: true,
    },
    {
      title: 'תחבורה והתניידות בפאי',
      type: 'text',
      content:
        'העיירה עצמה קטנה וניתן לנוע בה רגלית, באמצעות אופניים או אופנועים קטנים/ קטנועים במחירים אותם ניתן לשכור במחירים נוחים וזוהי האופציה הפופולרית ביותר בקרב המבקרים בעיירה. למי שאינו מנוסה ברכיבה, ניתן לשכור גם רכבי שטח קטנים (ATV) או מכוניות פרטיות.<br/><br/>ע"מ להגיע לאטרקציות שמחוץ למרכז העיירה, כמו Pai Canyon, המעיינות החמים או המפלים שבאזור, תצטרכו אמצעי תחבורה. האופציה הנפוצה ביותר הינה השכרת קטנוע בעלות נמוכה ועם זאת, הכבישים באיזור, חלקם תלולים ומפותלים ולכן חשוב להקפיד על נהיגה זהירה במיוחד, ודאי במידה ואין לכם ניסיון קודם. אופציה נוספת הינה לשכור נהג מקומי או להשתמש בטנדרים משותפים - סונגטאו (רכב שירות) היוצאים מהתחנה המרכזית.<br/><br/>הדרך המומלצת ביותר להתניידות באזור זה , הינה באמצעות רכב שכור, מצב שיאפשר לכם להנות, הן מהדרך אל/ מהעיירה והן מהאטרקציות המהממות שבסביבות העיירה.',
    },
    {
      title: 'חופים מרכזיים בפאי',
      type: 'text',
      content:
        'פאי הינה עיירת הרים, אין בה חופים כמו בדרום תאילנד. עם זאת, ניתן ליהנות מאזורי שכשוך בנהר פאי, במעיינות החמים הרבים שבאזור ובסמוך למפלים הרבים שבאזור.',
    },
    {
      title: 'אטרקציות ופעילויות מרכזיות בפאי ובסביבתה',
      type: 'sub-headers',
      description:
        'פאי וסביבתה מציעים מגוון רחב של פעילויות המתאימות לחובבי טבע, הרפתקאות ורוגע:',
      content: [
        {
          subtitle: 'טרקים ומפלים',
          text: 'המרחב ההררי הסובב את העיירה, שופע שבילי הליכה העוברים דרך יערות, כפרים, שדות אורז ונחלים. ניתן לצאת למסלולי הליכה מרהיבים, הכוללים ביקור במפלים כגון מפלי Mo Paeng ו - Pam Bok הפופולריים.',
        },
        {
          subtitle: 'רפטינג/ קאיקים בנהר פאי',
          text: 'חוויית שיט מהנה ורטובה המתאימה שהינה אחת החוויות המרגשות באזור זה - השייט נמשך מספר שעות וכולל מעבר במים גולשים ונופים ירוקים מסביב. מתאים בעיקר לעונת הגשמים כשהנהר מלא ומתאים הן להרפתקנים והן למתחילים. פעילות זו כוללת בדרך כלל מדריך מקצועי וציוד מלא.',
        },
        {
          subtitle: 'מעיינות חמים',
          text: 'פאי ידועה במעיינותיה החמים, בתוך יערות ירוקים:<br/><strong>Sai Ngam Hot Springs</strong> - מעיינות קטנים אך טבעיים, פופולריים במיוחד בקרב תרמילאים בשל מחירים זולים ואווירה טבעית.<br/><strong>Tha Pai Hot Springs</strong> - מרחב מסודר יותר עם מספר בריכות בטמפרטורות משתנות, מוקף בטבע שקט - מושלם לביקור בשעות הבוקר.',
        },
        {
          subtitle: 'Pai Canyon',
          text: 'אחת מנקודות החובה! מדובר בתצורת קרקע ייחודית המזכירה קניונים בארה"ב, עם שבילים צרים ונופים מרהיבים של עמקים והרים. השקיעות כאן יוצאות דופן - השמש שוקעת בין ההרים, והאור משתנה בכל רגע. זהירות - חלק מהשבילים צרים ומאתגרים.',
        },
        {
          subtitle: 'Baan Santichon',
          text: 'כפר קטן אשר הוקם על ידי מהגרים סינים ממחוז יונאן. המקום משמר את התרבות הסינית המסורתית וניתן למצוא בו מסעדות עם אוכל מסורתי של מחוז יונאן, שוק קטן, תצפית יפה על כל האזור - תצפית Yun Lai ובית תה מקומי. מתאים לביקור קצר וטעימה של תרבות שונה באזור.',
        },
        {
          subtitle: 'מקדש Phra That Mae Yen',
          text: 'מכונה "המקדש הלבן", ממוקם על גבעה הצופה על כל העיירה ומפורסם בזכות פסל הבודהה הלבן הענק אשר מושך אליו מבקרים בכל שעות היום. העלייה דורשת טיפוס של כ - 120 מדרגות, אך הנוף הנשקף מהמקדש מרהיב, במיוחד בשעות הזריחה או השקיעה.',
        },
        {
          subtitle: 'The Memorial Bridge',
          text: 'נבנה על ידי היפנים במלחמת העולם השנייה, על מנת להוביל ציוד ואספקה. כיום, הגשר הינו גשר עץ שחודש והפך לאתר תיירותי ונקודת צילום. הגשר חוצה את נהר פאי ומהווה סמל היסטורי לעברו של האזור.',
        },
        {
          subtitle: 'מערת לוד Tham Lod Cave',
          text: 'אחת המערות היפות בתאילנד - מערה עצומה עם נהר תת-קרקעי החוצה אותה לאורכה וכוללת נהר זורם ונטיפים מרהיבים. היא ממוקמת כשעה נסיעה מפאי ומהווה יעד מושלם לטיול יום. בתוך המערה - הליכה מהנה תוך צפייה בנטיפים מרשימים וציורי קיר עתיקים ושייט על רפסודות עץ בתוך המערה. המקום מנוהל על ידי קהילות מקומיות והביקור מלווה ע"י מדריכים עם פנסים - חוויה טבעית ומיוחדת המתאימה גם למשפחות. בדרך אל/ מהמערה, מומלץ לעצור בנקודת התצפית Doi Kiew Lom.',
        },
      ],
    },
    {
      title: 'מוזיאונים ואתרי תרבות בפאי',
      type: 'sub-headers',
      description: 'פאי מציעה כמה אתרי תרבות מעניינים:',
      content: [
        {
          subtitle: 'Baan Santichon',
          text: 'כפר סיני המשמר את המסורת של בני המיעוט הסיני ממחוז יונאן באזור וניתן למצוא בו מסעדות עם אוכל מסורתי של מחוז יונאן, שוק קטן, תצפית יפה על כל האזור - תצפית Yun Lai ובית תה מקומי.',
        },
        {
          subtitle: 'מקדשים מקומיים',
          text: 'כולל Wat Luang אשר במרכז העיירה ו - Wat Nam Hu אשר בדרך ל - Baan Santichon, המשמרים את רוח הבודהיזם הצפוני.',
        },
      ],
    },
    {
      title: 'חוויות קולינריות בפאי',
      type: 'text',
      content:
        "פאי מתהדרת בסצנת קולינריה עשירה ומגוונת - ממסעדות תאילנדיות מקומיות, דרך דוכני רחוב ועד בתי קפה ובייקרי'ז נוסח מערבי. מומלץ להצטרף לשיעורי בישול מקומי, לטעום תה בכפר הסיני Baan Santichon ולבקר בשוק הלילה, בו תמצאו מבחר גדול של דוכני אוכל רחוב, כולל מנות בינלאומיות כמו טאקו, שווארמה, פיצה, קרפים, סושי ועוד, במחירים השווים לכל כיס.",
    },
    {
      title: 'מסעדות מומלצות בפאי',
      type: 'sub-headers',
      description: 'מבחר מסעדות איכותיות בעיירה:',
      content: [
        {
          subtitle: 'Wellching Well',
          text: 'מסעדה אירופאית באווירה בוהמיינית.',
        },
        {
          subtitle: 'Silhouette by Reverie Siam',
          text: "מטבח פיוז'ן בתוך מלון בוטיק מהמם.",
        },
        {
          subtitle: 'Earth Tone',
          text: 'מסעדה-קפה פופולרית המתמחה במנות טבעוניות, שייקים בריאים ולחמים מקמח מלא, באווירה שקטה ונעימה.',
        },
        {
          subtitle: 'Om Garden Café',
          text: 'מקום אהוב עם ארוחות בוקר מושקעות, קפה איכותי וגינה מטופחת. במקום, מושם דגש על בריאות וכן ישנן מנות טבעוניות.',
        },
        {
          subtitle: 'Charlie & Lek',
          text: 'מנות תאילנדיות אותנטיות ומקומיות עם מנות כמו פאד תאי, קארי מסמאן ומרק טום יאם - זולה ומצוינת.',
        },
      ],
    },
    {
      title: 'קניות ופנאי בפאי',
      type: 'text',
      content:
        'פאי אינה יעד שופינג קלאסי, אך ניתן למצוא בה מגוון חנויות ודוכנים עם יצירות אמנות, בגדי יד שנייה, תכשיטים בעבודת יד, קוסמטיקה טבעית, סבונים מקומיים ועוד.<br/><br/>שוק הלילה הוא היעד המרכזי עבור קניות - ניתן למצוא בו פריטים ייחודיים שלא תמצאו ביעדים אחרים ובד בבד, לתמוך באמנים מקומיים.<br/><br/>חנויות כמו Pai Siam shop gallery ו - Art in Chai מציגות פריטי אומנות מקומית, ציורים, כלי קרמיקה ופריטי עיצוב לבית. ישנן גם כמה חנויות יד שנייה ומוצרים טבעיים, במיוחד כאלה אשר מוצריהן מיוצרים על ידי קהילות מקומיות.',
    },
    {
      title: 'חיי לילה בפאי',
      type: 'sub-headers',
      description:
        'למרות היותה עיירה קטנה, מציעה פאי חיי לילה תוססים באווירה רגועה. פאי מציעה פאבים וברים קטנים, אינטימיים ומזמינים, עם מוזיקה חיה, שיחות עם מטיילים מכל העולם וקוקטיילים צבעוניים.',
      content: [
        {
          subtitle: 'Walking Street',
          text: 'מופעים חיים, הופעות רחוב ודוכני אוכל.',
        },
        {
          subtitle: 'Yellow Sun Bar',
          text: 'בר מקומי ואותנטי על רחוב שוק הלילה, מציע מוזיקה חיה, אווירה חמה ומשקאות במחירים נוחים. המקום מהווה נקודת מפגש פופולרית לתרמילאים.',
        },
        {
          subtitle: "Don't Cry Bar",
          text: 'ממוקם מחוץ למרכז העיירה (מעבר לנהר), פועל עד השעות הקטנות, מושך קהל צעיר עם מסיבות ריקודים תחת כיפת השמיים. אווירה צעירה ומאוד שלווה.',
        },
        {
          subtitle: '',
          text: 'בפאי (כמו בשאר תאילנד), מחייבים סגירת ברים בשעה החוקית, אך לעיתים מקומות נפתחים שוב בצורה זו או אחרת.',
        },
      ],
    },
    {
      title: 'טיולי יום מסביב לפאי',
      type: 'sub-headers',
      description: 'פאי מהווה בסיס מצוין לטיולי יום באזור:',
      content: [
        {
          subtitle: 'טיול יום למערת לוד (Tham Lod Cave) ולתצפית Doi Kiew Lom',
          text: 'טיול חובה הכולל שייט רפסודות ונופים מהממים בתוך המערה. ניתן לשלב בטיול זה אף את מפל Mo Paeng.',
        },
        {
          subtitle: 'טיול יום לכפרי השבטים באזור',
          text: 'כולל שבטיי הקארן, ליסו ואחרים.',
        },
        {
          subtitle: 'מפלים ומעיינות מרוחקים',
          text: 'כגון גייזר Pong Duet ומעיינות חמים Pa Pae, מתאים למחפשים אתרים מעניינים אך לא מתויירים. ניתן לשלב בטיול זה אף את מפל Pam Bok, The Memorial Bridge ו - Pai Canyon.',
        },
        {
          subtitle: 'טיול יום למה הונג סון',
          text: "עדיפות ללינת לילה בעיר - טיול שיכלול ביקור בנקודות עניין מיוחדות, הן בדרך עצמה והן בסביבות העיר מה הונג סון, כדוג' Phu Klon Spa, Pha Sua Waterfall, הכפר Ban Rak Thai ו - Tham Pla Nam Tok Pha.",
        },
      ],
    },
    {
      title: 'ספא ומרכזי בריאות בפאי',
      type: 'sub-headers',
      description: 'פאי מציעה מגוון מרכזי ספא ובריאות איכותיים:',
      content: [
        {
          subtitle: 'Pai Yoga Shala',
          text: 'מרכז יוגה שקט ומקצועי הממוקם בקרבת העירה, בתוך הסביבה הטבעית קסומה. המקום מציע שיעורי יוגה יומיים בכל הרמות, סדנאות נשימה ומדיטציה, ואף ריטריטים מרוכזים למספר ימים. השיעורים מתקיימים על רצפת עץ פתוחה עם תקרה גבוהה, מוקפת בטבע ירוק ושלווה, וחוויית יוצרים של ריפוי גופני ונפשי כאחד.',
        },
        {
          subtitle: 'Sapaiya Spa',
          text: 'ספא בוטיק איכותי ומומלץ במרכז, המציע מגוון טיפולים פאי לצד טיפולים מודרניים כמו עיסוי שמנים ארומתרפיים, טיפול שוודי, טיפולי פנים ועיסויים רפואיים. המקום שם דגש על שימוש בחומרי גלם טבעיים, אווירה רגועה ועיצוב תאילנדי אותנטי עם ניחוח יוקרה. צוות המטפלים מקצועיים במיוחד, ומתאים לך לצורכי הלקוח.',
        },
        {
          subtitle: 'The Oia Pai Spa',
          text: 'ספא יוקרתי במתחם נופש נוסח ים - תיכוני. המקום מציע אווירה ייחודית עם טיפולים הוליסטיים, חדרי טיפול פרטיים הצופים על אגם מלאכותי, זוגיים עם אמבטיות פרחים. מתאים במיוחד לזוגות המחפשים פינוק זוגי מלא רוגע וניחוח של חופשה.',
        },
      ],
    },
    {
      title: 'חוויות למשפחות עם ילדים בפאי',
      type: 'sub-headers',
      description: 'פאי מציעה פעילויות מתאימות למשפחות:',
      content: [
        {
          subtitle: 'שייט קיאקים רגוע ובילוי באזורי שכשוך בנהר',
          text: 'הנהר פאי מציע חוויות מים בטוחות ומהנות לכל המשפחה. שייט קיאקים רגוע או אבובים מתאימים גם לילדים, כשלכל אורך המסלול תמצאו אזורים רדודים בהם ניתן לעצור, לשכשך רגליים וליהנות מהטבע הפראי באווירה של פיקניק משפחתי.',
        },
        {
          subtitle: 'מסלולי הליכה קצרים בטבע',
          text: 'במפלי המים הפופולריים Mo Paeng ו - Pam Bok - שני המפלים הללו נגישים יחסית ומתאימים מאוד לטיול משפחתי. במפלי Mo Paeng ניתן להיכנס לבריכות קטנות וישנם גם סלעים חלקים המאפשרים גלישה טבעית לילדים (בליווי מבוגרים). מפל Pam Bok מציע טיול קליל ביער עבות ונוף ירוק מרגיע.',
        },
        {
          subtitle: 'ביקור במערת לוד ובכפרי שבטי ההרים שבדרך',
          text: 'מערת לוד (Tham Lo Cave) מרשימה במיוחד עבור ילדים עם נטיפים מרהיבים ושייט על רפסודה בתוך המערה החשוכה. בדרך ניתן לעצור בכפרים של שבטי ההרים כמו שבט הליסו או הקארן - חוויה תרבותית מרתקת המשלבת נופים, לבוש מיוחד ומלאכות יד מקומיות.',
        },
      ],
    },
    {
      title: 'חוויות רומנטיות וזוגיות בפאי',
      type: 'sub-headers',
      description: 'פאי מציעה חוויות רומנטיות מיוחדות לזוגות:',
      content: [
        {
          subtitle: 'צפייה בשקיעה ב - Pai Canyon',
          text: 'מומלץ להגיע כשעה לפני השקיעה - קניון פאי הוא אחד מאתרי התצפית המרשימים בצפון תאילנד. לקראת השקיעה, המקום מתמלא מטיילים ובהם זוגות המחפשים רגע קסום מול שמיים הנצבעים בזהוב ובכתום. ההליכה לאורך רכסי הקניון מגלה פינות שקטות ורומנטיות - מושלם לתמונות זוגיות או אפילו הצעת נישואין בלתי נשכחת.',
        },
        {
          subtitle: 'ספא זוגי באחד ממרכזי הספא המובילים בעיירה',
          text: 'פאי מציעה מגוון מרכזי ספא ברמה גבוהה, בהם ניתן ליהנות מעיסוי תאילנדי זוגי, טיפולי ארומתרפיה או אמבט צמחים מקומי. מרכזים כמו Sapaiya Spa או Pai Yoga Shala מציעים חבילות ספא/ יוגה ​​זוגיות עם נוף לגבעות ומרפסת פרטית - חוויה מושלמת לרוגע ולרומנטיקה.',
        },
        {
          subtitle: 'צילום זוגי רומנטי',
          text: 'מעבר ל - Pai Canyon בסמוך לשקיעת השמש, Koung Kham Bridge והנהר פאי בסמוך לשקיעת השמש, מהווים אף הם אתרים פוטוגניים לצילומים זוגיים.',
        },
        {
          subtitle: 'סדנת בישול תאילנדי זוגית',
          text: 'אם הינכם אוהבים לבשל יחד, סדנת בישול מקומית הינה הזדמנות נפלאה ללמוד להכין מנות תאילנדיות קלאסיות כפאד תאי, קארי ירוק וסלט פאפאיה ותוך כדי, להנות מחוויה זוגית. סדנת הבישול Pai Cookery Class, הינה חוויה המשלבת אף ביקור בשוק המקומי והסברים מתוך התרבות המקומית.',
        },
        {
          subtitle: 'ארוחת ערב באחת מהמסעדות הרומנטיות ולמול הנוף',
          text: "פאי מציעה מגוון מסעדות רומנטיות עם נוף מרהיב לעמק הירוק או להרים מקיפים את העיירה. בין המומלצות:<br/><strong>Blue Ox</strong> - מסעדה אלגנטית עם מבחר בשרים, פסטות ומנות פיוז'ן, המשקיפה על נחל קטן וגינה טרופית.<br/><strong>Silhouette by Reverie Siam</strong> - מסעדת שף יוקרתית עם תפריט ים תיכוני עשיר, מנות מוקפדות ואווירה שלווה מול ההרים.<br/>ארוחת ערב בשעת שקיעה, בליווי יין מקומי ומוזיקה שקטה, ודאי וודאי למול הנוף המקומי, הינה חוויה אינטימית ובלתי נשכחת.",
        },
        {
          subtitle: "לינה בבונגלוס רומנטיים עם ג'קוזי פרטי ונוף הררי",
          text: "פאי מציעה מקומות אירוח מבודדים המתאימים לזוגות שמחפשים חוויה רומנטית:<br/><strong>Pai Village Boutique Resort</strong> - מציע בונגלוס מעוצבים בסגנון תאילנדי עם פרטיות, ג'קוזי חיצוני ונוף לעמק פאי.<br/><strong>Puripai Villa</strong> - לינה יוקרתית בוילות עם בריכות אינפיניטי, מרפסות עץ ופינות ישיבה מול הרי פאי.<br/><strong>Pai Hotsprings Spa Resort</strong> - לינה בחדרי אירוח פרטיים בטבע, עם מרפסת הצופה אל הירוק והשלווה, בריכה חיצונית גדולה ושירותי מסאג' עד לחדר.<br/><strong>Bura Lumpai Resort</strong> - ריזורט כפרי ופסטורלי הממוקם סמוך לגשר הזיכרון ולנהר פאי. החדרים מעוצבים בנוסח תאילנדי אותנטי והווילות הזוגיות כוללות ג'קוזי פרטי ומרפסת עם נוף לנהר. מתאים במיוחד למבקשים להיות מוקפים בטבע, שקט ופרטיות.",
        },
        {
          subtitle: '',
          text: 'חוויית השהייה במקומות אלה, מביאה עימה שלווה מוחלטת, ציוץ ציפורים בבוקר ורוח קרירה בלילה - אידיאלי לחופשה זוגית.',
        },
      ],
    },
    {
      title: 'פסטיבלים ואירועים מיוחדים בפאי',
      type: 'sub-headers',
      description: 'פאי מארחת מספר פסטיבלים מיוחדים במהלך השנה:',
      content: [
        {
          subtitle: 'Loi Krathong',
          text: 'אחד הפסטיבלים המרגשים והיפים ביותר בתאילנד, מתקיים מדי שנה בחודש נובמבר. במהלך הפסטיבל, משחררים התושבים המקומיים והמבקרים מנחות ונרות קטנים הצפים בתוך קונכיות לוטוס (קרטונגים) על פני הנהר. העיירה פאי, עם הנהר השקט והאווירה האינטימית שלה, הופכת למקום מושלם לחוות את הטקס המסורתי הזה באווירה קסומה ורוחנית במיוחד. זהו זמן של סליחה, תודה והתחדשות.',
        },
        {
          subtitle: 'Pai Jazz & Blues Festival',
          text: "פסטיבל הג'אז והבלוז של פאי הינו אירוע שנתי (השנה, 2025, יתקיים בין 18 ל - 20 ביולי) ומושך אליו מוזיקאים מוכשרים מכל רחבי תאילנד והעולם. הרחובות והברים של פאי מתמלאים בהופעות חיות של ג'אז, בלוז ופיוז'ן באווירה נינוחה, פתוחה ומזמינה. הפסטיבל מפיק מוזיקה איכותית ומעניק חוויה מוזיקלית בלתי נשכחת תחת כיפת השמיים.",
        },
        {
          subtitle: 'פסטיבל הפירות בצפון תאילנד',
          text: 'בחודשי הקיץ (לרוב ביוני), מתקיימים בצפון תאילנד פסטיבלים ססגוניים המוקדשים לשפע הפירות האקזוטיים של האזור: מנגו, דוריאן, רמבוטן, מנגוסטין ועוד. בפאי, הפסטיבל כולל דוכני טעימות, תחרויות חיתוך פירות, הופעות פולקלור ויריד מקומי. זוהי חגיגה של טעמים, צבעים וריחות, חוויה נהדרת במיוחד עבור חובבי אוכל ותרבות מקומית.',
        },
      ],
    },
    {
      title: 'מידע שימושי למטיילים בפאי',
      type: 'sub-headers',
      description: 'מידע חשוב לתכנון הביקור:',
      content: [
        {
          subtitle: 'שירותים בסיסיים',
          text: "✓ כספומטים זמינים <strong>בעיקר</strong> במרכז העיירה.<br /> ✓ הקליטה הסלולרית טובה, כולל אינטרנט, ברוב מקומות הלינה.<br /> ✓ בעיירה קיימת מרפאה קטנה, מרכזים רפואיים גדולים יותר, קיימים בצ'אנג מאי.<br /> ✓ שוק הלילה מתקיים מדי ערב ברחוב Chai Sangkhram.<br />",
        },
        {
          subtitle: 'טיפים חשובים',
          text: '✓ הדרך לעיירה מפותלת מאוד - במידה והינכם רגישים, קחו עימכם כדורים נגד בחילה.<br /> ✓ תכננו מינימום 2 עד 4 לילות, ע"מ להרגיש את האווירה המיוחדת.<br /> ✓ העונה היבשה (נובמבר - פברואר) הינה הזמן הטוב ביותר - אך גם העמוס ביותר.<br /> ✓ אל תשכחו מעיל קל - בלילות עלול להיות קריר.<br />',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'פאי הינה גן עדן למבקשים לחוות את צפון תאילנד האותנטית. עם שילוב ייחודי של נופים פראיים, מקומיים קטנים וחביבים, תרבות מגוונת ושלל פעילויות, מצליחה פאי לרגש כל סוג של מטייל. זהו יעד הגורם לרבים להמשיך ולטייל מעבר למתוכנן - ומי שמגיע, מבין מדוע פאי הופכת למיתוס בתרבות התרמילאית.',
    },
  ],
};
